import { Pipe, PipeTransform } from '@angular/core';
import { Postadresse } from 'src/app/api/models';

@Pipe({
  name: 'postAdresse',
})
export class PostAdressePipe implements PipeTransform {
  /**
   * Builds an address string from a Postadresse object
   * @param address Postadresse to be transformed into a display string
   * @param args
   */
  transform(address: Postadresse): string {
    let display: string;
    if (address) {
      display = `${address.vejnavn} ${address.husnummer}, `;
      if (address.etage) {
        display = display.concat(`${address.etage}., `);
      }
      if (address.doerbetegnelse) {
        display = display.concat(`${address.doerbetegnelse}, `);
      }
      display = display.concat(`${address.postnummer} ${address.postdistrikt}`);
    }
    return display;
  }
}
